import type { Figure, ScorecardMetric } from '@/types/dashboards'

/**
 * Server scorecard figures as the kit's bars.
 *
 * The one mapping every board uses, so a metric prints the same way on the
 * scorecard as on every other panel: the figure's `format` travels with it (a
 * 'pct' metric reads "0.0%", never a bare "0"). No target marker is drawn —
 * the payload carries no target — and a non-numeric value is absent, not 0.
 */
export function scorecardMetrics(figures: Figure[]): ScorecardMetric[] {
  return figures.map((figure) => ({
    key: figure.label,
    label: figure.label,
    value: typeof figure.value === 'number' ? figure.value : null,
    format: figure.format,
    target: null,
    tone: figure.tone,
    drill: figure.drill,
  }))
}
